<template>
  <div id="home">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <div
          class="floatLayerDiv"
          style="
            height: 100%;
            width: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: #c8d0dc;
          "
        >
          <img
            src="~assets/img/welcome2.jpg"
            class="mapPic"
            alt="Failed to load picture"
          />
        </div>
        <div class="loginRecordBox" style="margin-left: -35%">
          <el-link target="_blank">诺基亚上海贝尔版权所有</el-link>
          <el-link target="_blank">{{ $t('Version')+version }}</el-link>
        </div>
      </el-main>
    </el-scrollbar>
  </div>
</template>

<script>
import { getAppVersion } from "../../../api/api";
import { mapState } from "vuex";

export default {
  name: "DefaultHome",
  data() {
    return {
      version: "",
    };
  },
  methods: {
    getversion() {
      getAppVersion().then((res) => {
        if (res.success) {
          this.version = res.result;
        }
      });
    },
  },
  mounted() {
    this.getversion();
    const { $store } = this
   
    let langinfos = $store.getters.language
    $store.dispatch('applicationConfiguration',langinfos).then((res) => {
      })
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>
<style>
.el-popover {
  border: 0;
  padding: 0;
  /*box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0) !important;*/
}
h6 {
  margin-block-start: 1em;
  margin-block-end: 1em;
  width: 60%;
  margin: 0 auto;
}
</style>
<style scoped>
.el-main {
  padding: 0;
}

.el-dialog-div {
  height: 60vh;
  overflow: auto;
}
</style>
